<template>
  <section class="section" id="vending-categories-panel">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <vending-categories-title
      @get-vending-categories="getVendingCategories"
      @add-vending-category="addVendingCategory"
    />

    <h2
      v-if="vendingCategories.length === 0"
      class="subtitle has-text-centered"
      style="margin-top: 3rem;"
    >
      {{ $t("vending.noCategories") }}
    </h2>

    <div class="columns is-multiline" v-else>
      <vending-category-card
        v-for="v in vendingCategories"
        :key="v._id"
        :name="v.name"
        @edit-vending-category="editVendingCategory(v)"
      />
    </div>

    <b-modal :active.sync="isCategoryModalActive">
      <vending-category-modal
        :category="categoryBeingEdited"
        @get-vending-categories="getVendingCategories"
      />
    </b-modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import vendingCategoriesTitle from "./VendingCategoriesTitle";
import vendingCategoryCard from "./VendingCategoryCard";
import vendingCategoryModal from "./VendingCategoryModal";

export default {
  mixins: [common],

  components: {
    vendingCategoriesTitle,
    vendingCategoryCard,
    vendingCategoryModal
  },

  data() {
    return {
      isLoading: false,
      categoryBeingEdited: {},
      isCategoryModalActive: false
    };
  },

  methods: {
    getVendingCategories() {
      this.isLoading = true;
      this.$store
        .dispatch("getVendingCategories")
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    addVendingCategory() {
      this.categoryBeingEdited = {
        name: "",
        description: "",
        translations: {
          en: "",
          es: ""
        },
        forbiddenForMinors: false
      };
      this.isCategoryModalActive = true;
    },

    editVendingCategory(c) {
      this.categoryBeingEdited = c;
      this.isCategoryModalActive = true;
    }
  },

  computed: {
    ...mapGetters(["vendingCategories"])
  },

  mounted() {
    this.getVendingCategories();
  }
};
</script>

<style scoped>
#vending-categories-panel {
  margin-top: 3rem;
  min-height: 100vh;
  background-color: hsl(0, 0%, 96%);
}
</style>
